export enum IEdoVideoStatusEnum {
    UPLOADING = 'UPLOADING',
    UPLOADED = 'UPLOADED',
    PROCESSING = 'PROCESSING',
    READY = 'READY',
    ERROR = 'ERROR',
}
